import { goodEnoughUUID } from "../../../../../../../scanline/utils/uuid";

/* ************************
 * PRIVATE
 */

const isDefined = v => v !== undefined && v !== null;


/* ************************
 * PUBLIC - HELPERS
 */

const createMessageUuid = (message) => {
	const topic = message?.topic;
	const _uuid = goodEnoughUUID();
	return [_uuid, topic].filter(v => v).join('~');
}

const getTopicFromUuid = (uuid = '') => {
	const parts = uuid.split('~');
	return parts[1];
}

const injectMessageUuid = (message) => {
	if (!message || message.uuid) {
		return message;
	}

	const uuid = createMessageUuid(message);
	return {
		...message,
		uuid
	}
}


/* ************************
 * PUBLIC - CREATE MESSAGES
 */

const createFileUploadMessage = (topic, { uuid, desc = 'Uploading falcon verbose file...', isError, errDesc = 'Error uploading falcon verbose file to s3...', percentComplete = 0 } = {}) => {
	if (!topic) {
		throw new Error(`createFileUploadMessage(): invalid param: ${topic}`);
	}
	const ACTION = 'falcon-s3-upload';
	const MESSAGE_TYPE = 'falcon-s3-upload';

	return injectMessageUuid({
		uuid,
		topic,
		action: ACTION,
		messageType: MESSAGE_TYPE,
		isError,
		body: {
			desc,
			percentComplete,
			batch: 'AWS-UPLOAD',
			isError,
			errDesc,
		}
	})
}


const createMigrationStartMessage = (topic, { uuid, desc = 'Checking migration status..', isError, errDesc } = {}) => {
	if (!topic) {
		throw new Error(`createMigrationStartMessage(): invalid param: ${topic}`);
	}
	const ACTION = 'falcon-start-migration-monitor';
	const MESSAGE_TYPE = 'falcon-start-migration-monitor';

	return injectMessageUuid({
		uuid,
		topic,
		action: ACTION,
		messageType: MESSAGE_TYPE,
		isError,
		body: {
			desc,
			batch: 'STATUS-UPDATE',
			isError,
			errDesc,
		}
	})
}

const createMonitorFalconProcessorMessage = (topic, { uuid, desc = 'Falcon processor status..', batch, history, isError, errDesc, forceStop } = {}) => {
	if (!topic) {
		throw new Error(`createMonitorFalconProcessorMessage(): invalid param: ${topic}`);
	}
	const ACTION = 'monitor-falcon-processor';
	const MESSAGE_TYPE = 'monitor-falcon-processor';

	return injectMessageUuid({
		uuid,
		topic,
		action: ACTION,
		messageType: MESSAGE_TYPE,
		isError,
		body: {
			desc,
			batch: batch || 'STATUS-UPDATE',
			history,
			isComplete: desc === 'DONE',
			isError,
			errDesc,
			forceStop,
		}
	})
}

const UTIL_FALCON_UPLOAD_MESSAGE = {
	// HELPERS
	createMessageUuid,
	getTopicFromUuid,
	injectMessageUuid,

	// PUBLIC - CREATE MESSAGES
	createFileUploadMessage,
	createMigrationStartMessage,
	createMonitorFalconProcessorMessage,
}

export default UTIL_FALCON_UPLOAD_MESSAGE;